import 'quill/dist/quill.snow.css';
import './index.scss';

import Quill from 'quill';

import LowErrorErrorBlot from './lowErrorEmbed';
import SpellErrorBlot from './spellErrorEmbed';
import CustomErrorBlot from './customErrorEmbed';
import FindReplaceBlot from './findReplaceEmbed';
import HighlightBlot from './highlightEmbed';
import FontBlot from './fontEmbed';
import ImgBlot from './imgEmbed';
import EmBlot from './emEmbed';

// 修改默认加粗标签
const Bold = Quill.import('formats/bold');
Bold.tagName = 'B'; // Quill uses <strong> by default
Quill.register(Bold, true);

// 修改默认加粗标签
const Italic = Quill.import('formats/italic');
Italic.tagName = 'I';
Quill.register(Italic, true);

Quill.register(ImgBlot, true);
Quill.register(FontBlot, true);
Quill.register(SpellErrorBlot, true);
Quill.register(LowErrorErrorBlot, true);
Quill.register(CustomErrorBlot, true);
Quill.register(EmBlot, true);
Quill.register(FindReplaceBlot, true);
Quill.register(HighlightBlot, true);

export default Quill;
